class CertifiedGuide extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.parentElement.childNodes.forEach((node) => {
      if (node.nodeName === "#text") {
        this.parentElement.removeChild(node);
      }
    });

    let data;
    try {
      const source = this.querySelector("script");
      if (!source) return;

      data = JSON.parse(source.innerHTML);
    } catch (error) {
      console.warn("Error generating certified guides", error);
      return;
    }

    const content = data
      .map(({ image, name, phone }) => {
        const imageEl = `<img src="${image}" class="certified-guide__image">`;

        const nameEl = `<div class="certified-guide__name">${name}</div>`;

        const cta = `<a href="tel:${phone}" class="certified-guide__cta"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.082 16.0785C7.67172 15.5016 2.62927 10.4591 2.05373 4.05025C1.95832 2.98849 2.64404 2.02751 3.80193 1.92259V1.92242C5.78965 1.91532 6.07542 1.67965 6.73829 3.64402L6.73864 3.64385L7.26845 5.20542C7.71567 6.52306 6.38579 7.17141 6.30492 7.89561C6.29165 8.01457 6.30458 8.12718 6.35352 8.20625C7.42326 9.92932 8.20294 10.7085 9.92557 11.7783C10.6595 12.234 11.4314 10.3562 12.9265 10.8633L14.4881 11.3931L14.4879 11.3935C16.3935 12.0364 16.2166 12.3171 16.2191 14.1052C16.2193 14.1822 16.2161 14.2574 16.2095 14.33H16.2093C16.1048 15.488 15.1446 16.1736 14.0821 16.0785L14.082 16.0785ZM6.38794 11.7443C8.40743 13.7638 11.1152 15.0937 14.1438 15.3662C14.8993 15.4339 15.5059 14.9424 15.5043 14.1054L15.4999 12.9256C15.4981 12.4889 14.9046 12.2888 14.3565 12.1044L12.6968 11.542C11.8015 11.2383 11.3512 12.4235 10.3149 12.5391C10.0471 12.569 9.77301 12.5272 9.54727 12.3868C7.72431 11.2543 6.87762 10.4085 5.74531 8.58494C5.45999 8.12533 5.58201 7.46714 5.88788 7.05618C6.27887 6.53064 6.7938 6.03609 6.59005 5.4355L6.02763 3.77582C5.84304 3.22794 5.64321 2.63423 5.20651 2.6325L3.86509 2.63463C3.1601 2.66621 2.70348 3.29248 2.76592 3.98846C3.03859 7.01703 4.36842 9.7248 6.38791 11.7443L6.38794 11.7443Z" fill="currentColor"/>
        </svg>
        <span>${phone}</span></a>`;

        return `<div class="certified-guide__guide">${imageEl}${nameEl}${cta}</div>`;
      })
      .join("");

    this.innerHTML = `
      <details class="certified-guide__details">
        <summary class="certified-guide__summary">
          Certified Guides
          <svg class="certified-guide__summary-icon" width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.96967 12.5303C10.2626 12.8232 10.7374 12.8232 11.0303 12.5303L15.8033 7.75737C16.0962 7.46447 16.0962 6.9896 15.8033 6.69671C15.5104 6.40381 15.0355 6.40381 14.7426 6.69671L10.5 10.9393L6.25737 6.69669C5.96447 6.4038 5.4896 6.4038 5.19671 6.69669C4.90381 6.98958 4.90381 7.46446 5.1967 7.75735L9.96967 12.5303ZM9.75 11L9.75 12L11.25 12L11.25 11L9.75 11Z" fill="currentColor"/>
          </svg>
        </summary>
        <div class="certified-guide__content">
          ${content}
        </div>
      </details>
    `;
  }

  disconnectedCallback() {}
}

if (!customElements.get("certified-guide")) {
  customElements.define("certified-guide", CertifiedGuide);
}
